import types from '../types/types';

const initialState = {
  selectedEstadoId: null,
  selectedEstadoName: null,
};
const estadoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.selectEstado:
      return {
        ...state,
        selectedEstadoId: action.estadoId,
        selectedEstadoName: action.estadoName,
      };

    default:
      return state;
  }
};
export default estadoReducer;
